// 싱크상태 정의
export enum SYNC_STATUS {
  CHECKING = 'CHECKING',
  PROCESSING = 'PROCESSING',
  STOP = 'STOP',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
SYNCKEY_ERROR = 'SYNCKEY_ERROR',
}

export interface SyncTx {
id: string
type: string
amount: string
currency: string
date: any
direction: 'in' | 'out'
}